import Storage from '@/lib/Storage'
import { isEmpty } from '@/utils/isEmpty'
import StackAPI from '@/lib/StackAPI'
import { captureException } from '@sentry/react'

export const ENDPOINT = '/partners/vendor/chargebacks/breakdown'

type getChargebacksCsvProps = {
  saleId?: string
  startAt: string
  endAt: string
}

export const getChargebacksCsv = async ({
  saleId,
  startAt,
  endAt
}: getChargebacksCsvProps) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { get } = StackAPI()

  const headers = {
    Accept: 'text/csv',
    'Content-Type': 'text/csv'
  }

  const params = {
    sale_id: saleId,
    start_at: startAt,
    end_at: endAt
  }

  const request = {
    path: ENDPOINT,
    params,
    headers,
    responseType: 'blob'
  }

  try {
    const response = await get(request)

    return response.data
  } catch (error) {
    captureException(error, { extra: { role, params } })
    return { error: 'unknown error' }
  }
}
